<template>
  <Toaster richColors />
  <div class="min-h-screen flex flex-col">
    <NavBar />
    <main class="flex-1">
      <RouterView />
    </main>
    <Footer />
  </div>
  <CookieBanner />
</template>

<script setup lang="ts">
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import CookieBanner from "./components/CookieBanner.vue";
import { Toaster } from "@acme/ui";
import { applySeo } from "@/lib/seo";
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useBlueberry } from "@acme/api";
import "vue-sonner/style.css";

const route = useRoute();
const { locale } = useI18n();
const blueberry = useBlueberry().getBlueberry();
const price = computed(() =>
  blueberry.value.success ? blueberry.value.content.price : undefined,
);

if (!import.meta.env.SSR) {
  watch(
    [() => route.fullPath, () => locale.value, () => price.value],
    () => applySeo(route, locale.value, price.value),
    { immediate: true },
  );
}
</script>
